import PropTypes from 'prop-types';
import React from 'react';

import { __t } from '@mssgme/shared';
import { parseUrl, urlSafeComponent } from '@mssgme/helpers';
import { LinkBlank } from '@mssgme/ui';
import { ThemedButton } from '../ThemedButton';
import styles from './ServiceContent.scss';

export const ExternalUrlButton = ({ service, themeStyles }) => {
    const url = service.externalButton?.url || service.externalUrl;
    const parsed = url && parseUrl(url);

    if (!url) {
        return null;
    }

    return (
        <ThemedButton
            fullWidth
            tag={LinkBlank}
            theme={themeStyles}
            href={url}
            data-id={service._id}
            data-title={service.title || service.name}
            data-element="custom-link"
            data-event-name={urlSafeComponent(url)}
            className={styles.externalButton}
        >
            <div className={styles.buttonContent}>
                <span>{service.externalButton?.title || __t('visit_website')}</span>
                {!!parsed && <span className={styles.url}>{parsed.hostname}</span>}
            </div>
        </ThemedButton>
    );
};

ExternalUrlButton.propTypes = {
    service: PropTypes.object.isRequired,
    themeStyles: PropTypes.object.isRequired,
};
